import React, { useState } from 'react'
import { Grid, Select, MenuItem, FormControl, InputLabel, TextField, FormControlLabel, RadioGroup, Radio, Button, Switch } from '@mui/material'
import NumberFormat from 'react-number-format'

import { DialogProfileCatalogCat } from './DialogProfileCatalogCat'
import { useCatalog } from '../../hooks/useCatalog'
import { useSelector } from 'react-redux'

export const SeccionGeneral = ({ form, setForm, categorias, handleSave, initLoadCategorias, intCalcUtilidad }) => {

    const { categories: categoriasList } = useSelector(state => state.general)

    const {
        // local_id_moneda: id_moneda,
        // local_moneda: moneda,
        local_simbolo: simbolo,
        local_separacion_miles: separacion_miles,
        local_separacion_decimales: separacion_decimales
    } = useSelector(state => state.general.info)

    const { handleNewCat, handleUpdateCat } = useCatalog()
    const [newCat, setNewCat] = useState(false)

    const handleNumber = async (values, targetName) => {
        if (!values.sourceInfo.event) return false
        const infoUtilidad = await calcUtilidad(targetName, values.floatValue)
        setForm({
            ...form,
            [targetName]: values.floatValue,
            total_utilidad: infoUtilidad.utilidad,
            margen_utilidad: infoUtilidad.margen
        })
    }

    const handleChange = async ({ target }) => {
        const { name, value, type, checked } = target
        const newValue = (type === 'checkbox' ? checked : value)
        setForm({
            ...form,
            [name]: newValue
        })
    }

    const calcUtilidad = async (targetName, newValue) => {
        const precioVenta = parseFloat(targetName === 'precio_venta' ? newValue : (form?.precio_venta || 0))
        const precioCosto = parseFloat(targetName === 'precio_costo' ? newValue : (form?.precio_costo || 0))
        const utilidad = precioVenta - precioCosto
        const margen = (utilidad / precioVenta) * 100
        return {
            utilidad,
            margen
        }
    }

    return (
        <div className='mt-3'>
            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                <Grid item xs={12}>
                    <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                        {form.id > 0 &&
                            <FormControlLabel
                                className="ms-2"
                                control={
                                    <Switch
                                        style={{ color: form?.estado ? '#8E24AA' : '' }}
                                        name="estado"
                                        checked={form?.estado}
                                        onChange={handleChange}
                                    />
                                }
                                label={form?.estado ? 'Habilitado' : 'Desactivado'}
                            />
                        }

                        <Grid item xs={12}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="tipo"
                                    onChange={handleChange}
                                >
                                    <FormControlLabel
                                        value="venta"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form.tipo === 'venta' ? true : false} />}
                                        label="Venta"
                                    />
                                    <FormControlLabel
                                        value="compra"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form.tipo === 'compra' ? true : false} />}
                                        label="Compra"
                                    />
                                    <FormControlLabel
                                        value="ambos"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form.tipo === 'ambos' ? true : false} />}
                                        label="Compra/venta"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <div className='p-info'>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Categoría (*)</InputLabel>
                                    <Select
                                        label="Categoría (*)"
                                        id="id_categoria"
                                        name="id_categoria"
                                        value={form.id_categoria || ''}
                                        onChange={handleChange}
                                        className='p-list-capitalize'
                                    >
                                        <MenuItem value='' key=''>Ninguno</MenuItem>
                                        {categoriasList.map(item => (
                                            <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                                {item.codigo ?
                                                    <span>{item.nombre}{' / '}{item.codigo}</span>
                                                    :
                                                    <span>{item.nombre}</span>
                                                }
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>

                        {newCat &&
                            <DialogProfileCatalogCat
                                open={newCat}
                                setOpen={setNewCat}
                                initialState={{ id: 0, nombre: '', tipo: 'venta' }}
                                handleNewCat={handleNewCat}
                                handleUpdateCat={handleUpdateCat}
                                initLoadCategorias={initLoadCategorias}
                            />
                        }

                        <Grid item xs={12} md={4} className="text-center">
                            {/* <a href="#" className='p-link-add' onClick={() => setNewCat(true)}>+ Nueva categoría</a> */}
                            <button className='p-link-add' onClick={() => setNewCat(true)}>+ Nueva categoría</button>
                        </Grid>

                        <Grid item xs={4}>
                            <div className='p-info'>
                                <TextField
                                    className='p-info-code '
                                    label="Código"
                                    name="codigo"
                                    id="outlined-size-small"
                                    value={form.codigo || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese código'
                                    onChange={handleChange}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={8}>
                            <div className='p-info'>
                                <TextField
                                    label="Nombre servicio (*)"
                                    name="servicio"
                                    id="outlined-size-small"
                                    value={form.servicio || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese nombre servicio'
                                    onChange={handleChange}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <div className='p-prices-services'>
                                <NumberFormat
                                    style={{ width: '100%' }}
                                    label="Precio unitario"
                                    customInput={TextField}
                                    value={form?.precio_venta || 0}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={simbolo}
                                    decimalScale={2}
                                    onValueChange={(values, sourceInfo) => handleNumber({ ...values, sourceInfo }, 'precio_venta')}
                                />
                            </div>
                            <div className='text-end' style={{ color: 'white', fontSize: '16px' }}>--</div>
                        </Grid>

                        <Grid item xs={4}>
                            <div className='p-prices-services'>
                                <NumberFormat
                                    style={{ width: '100%' }}
                                    label="Costo unitario"
                                    customInput={TextField}
                                    value={form?.precio_costo || 0}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={simbolo}
                                    decimalScale={2}
                                    onValueChange={(values, sourceInfo) => handleNumber({ ...values, sourceInfo }, 'precio_costo')}
                                />
                            </div>
                            <div className='text-end' style={{ color: 'white', fontSize: '16px' }}>--</div>
                        </Grid>

                        <Grid item xs={4}>
                            <div className='p-prices-services'>
                                <NumberFormat
                                    style={{ width: '100%' }}
                                    label="Total utilidad"
                                    customInput={TextField}
                                    value={form?.total_utilidad || 0}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={simbolo}
                                    decimalScale={2}
                                    disabled
                                    onValueChange={(values, sourceInfo) => handleNumber({ ...values, sourceInfo }, 'total_utilidad')}
                                />
                            </div>
                            <div className='text-end' style={{ fontSize: '16px' }}>
                                <NumberFormat
                                    displayType={'text'}
                                    label="Margen"
                                    value={form?.margen_utilidad || 0}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    decimalScale={2}
                                    suffix='%'
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static"
                                name="descripcion"
                                label="Descripción"
                                multiline
                                rows={6}
                                value={form.descripcion}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} className="text-end">
                            {/* {form.id > 0 &&
                                <Button
                                    id="id-button-save-ppto"
                                    disabled={initialState === form}
                                    className='p-btn-primary'
                                    variant="contained"
                                    size='medium'
                                    onClick={() => setSaveAndExit('actualizar')}
                                    type='submit'
                                >
                                    {''}Actualizar
                                </Button>
                            } */}

                            {/* {form.id == 0 &&
                                <>
                                    <Button
                                        disabled={initialState === form}
                                        className='p-btn-primary-large'
                                        variant="contained"
                                        size='medium'
                                        onClick={() => setSaveAndExit('saveAndMore')}
                                        type='submit'
                                    >
                                        {''}Guardar y agregar más
                                    </Button>
                                    <Button
                                        disabled={initialState === form}
                                        className='p-btn-primary-large ms-2'
                                        variant="contained"
                                        size='medium'
                                        onClick={() => setSaveAndExit('saveAndExit')}
                                        type='submit'
                                    >
                                        {''}Guardar y salir
                                    </Button>
                                </>
                            } */}

                            <Button
                                className='p-btn-primary-large ms-2'
                                variant="contained"
                                size='medium'
                                onClick={handleSave}
                                type='button'
                            >
                                {''}Guardar
                            </Button>

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>
        </div>
    )
}
